// Changements entre deux versions du catalogue du matériel, en clair (historique de la page Catalogue, 30/10/2026) :
// « Professionnel › Onduleurs › FOX ESS P3-Pro-15 : prix d'achat 1 200 → 1 250 ».

const LIBELLES: { [cle: string]: string } = {
  particulier: 'Particulier', pro: 'Professionnel', panneaux: 'Panneaux', integrations: "Systèmes d'intégration", onduleurs: 'Onduleurs',
  batteries: 'Batteries', optimiseur: 'Optimiseur', backupMono: 'Backup monophasé', backupTri: 'Backup triphasé',
  batteriesCq7: 'CQ7', batteriesPowerKeeper: 'PowerKeeper', powerstack: 'Powerstack', kits: 'Kits', backup: 'Backup',
  coffret: 'coffret', protection: 'protection', cables: 'Câbles', abaqueCable: 'Abaque des câbles', tranches: 'Tranches',
  agri: 'agricole', ict: 'ICT', mainOeuvre: "Main d'œuvre", maintenance: 'Maintenance', assurance: 'Assurance',
  joursPose: 'Temps de pose', joursPoseFixes: 'Temps de pose fixe', joursElectricite: 'Travaux électriques sans batterie',
  joursElectriciteBatterie: 'Travaux électriques avec batterie', ratios: 'Ratios', limites: 'Limites de puissance',
  defautsEtudes: 'Valeurs par défaut des études', datalogger: 'Datalogger', hypotheses: 'Hypothèses provisoires',
  estimations: 'Valeurs estimées',
  prix: "prix d'achat", prixParPanneau: "prix d'achat", eurParWc: "prix d'achat (€/Wc)", electriciteEurParWc: "prix d'achat (€/Wc)",
  prixMaitre: "prix d'achat maître", prixEsclave: "prix d'achat esclave", prixBloc: "prix d'achat bloc",
  prixBoiteJonction: "prix d'achat boîte de jonction", kva: 'puissance AC max', kwh: 'capacité', wc: 'puissance',
  m2: 'surface', tva55: 'TVA 5,5', veilleW: 'conso de veille', chargeKw: 'charge max', dechargeKw: 'décharge max',
  batterieChargeKw: 'charge max batteries', batterieDechargeKw: 'décharge max batteries', entreesBatterie: 'entrées batterie',
  tensionBatterieMinV: 'tension batterie min', kwcMax: "jusqu'à", jours: 'jours', montant: 'montant', section: 'section',
  margeMaterielPct: 'marge du matériel PV', margeBatteriePct: 'marge de la batterie', tarifJour: 'tarif par jour',
  tarifNuit: 'tarif par nuit', poseurs: 'poseurs', electriciens: 'électriciens', marque: 'fabricant', ref: 'modèle', nom: 'modèle',
  reseau: 'réseau (défaut)', hybride: 'hybride', reseauMaxBe: 'réseau (max)', hybrideMaxBe: 'hybride (max)',
  // 03/11/2026
  marges: 'Marges minimales', pv: 'installation PV', batterie: 'batterie', presta: 'prestations externes', bornes: 'Bornes de charge',
  visible: 'visible', typologies: 'typologies de toiture', panneau: 'panneaux du carport', panneauxParUnite: 'panneaux par carport',
  filetsSousToiture: 'filet sous toiture', longueur: 'longueur', largeur: 'largeur', garantiePerformancePct: 'garantie de performance (%)',
  garantiePerformanceAns: 'garantie de performance (ans)', garantieMaterielleAns: 'garantie matérielle', garantie10: 'garantie 10 ans',
  garantie15: 'garantie 15 ans', garantie20: 'garantie 20 ans', engins: 'Engins', nacellePrixJour: 'nacelle (prix par jour)',
  telescopiquePrixJour: 'télescopique (prix par jour)', inclinee: 'toiture inclinée', terrasse: 'toiture terrasse', bipv: 'toiture BIPV',
  sol: 'centrale au sol', ombriere: 'ombrières', poseNacelles: 'nacelles (pose)', poseTelescopiques: 'télescopiques (pose)',
  elecNacelles: 'nacelles (électricité)', elecTelescopiques: 'télescopiques (électricité)', prestations: 'Prestations',
  ombriereStructure: 'Structure des ombrières', ombrierePose: 'Pose des ombrières', filetsEurParWc: 'filets (€/Wc)',
  bacAcierSeuilM2: 'bac acier : seuil', bacAcierPrixM2Petit: 'bac acier : prix sous le seuil', bacAcierPrixM2Grand: 'bac acier : prix au-delà',
  shelter: 'Shelter', onduleursMax: "jusqu'à (onduleurs)", tranchesSol: 'Tranches au sol', tranchesOmbriere: 'Tranches des ombrières',
}

// sans intérêt pour l'administrateur
const IGNORES = ['format', 'source', 'manquants', 'aVerifier']

function libelle(cle: string): string { return LIBELLES[cle] || cle }

/** Nom d'un article d'une liste : fabricant et modèle, sinon tranche, sinon numéro. */
function nomElement(e: any, i: number): string {
  if (e && typeof e === 'object') {
    const nom = [e.marque, e.ref || e.nom].filter(x => x).join(' ')
    if (nom) return nom
    if ('kwcMax' in e) return e.kwcMax == null ? 'dernière tranche' : "jusqu'à " + texte(e.kwcMax) + ' kWc'
    if ('kva' in e) return texte(e.kva) + ' kVA'
    if ('integration' in e) return e.integration
  }
  return 'n° ' + (i + 1)
}

function texte(v: any): string {
  if (v === null || v === undefined || v === '') return 'vide'
  if (typeof v === 'boolean') return v ? 'oui' : 'non'
  if (typeof v === 'number') return v.toLocaleString('fr-FR', { maximumFractionDigits: 4 }).replace(/ | /g, ' ')
  return String(v)
}

function estListeDeTextes(v: any): boolean {
  return Array.isArray(v) && v.every(x => typeof x !== 'object' || x === null)
}

function comparer(avant: any, apres: any, chemin: string[], sortie: string[]) {
  if (estListeDeTextes(avant) || estListeDeTextes(apres)) {
    const a = avant || [], b = apres || []
    b.filter((x: any) => !a.includes(x)).forEach((x: any) => sortie.push(chemin.join(' › ') + ' : ajout « ' + x + ' »'))
    a.filter((x: any) => !b.includes(x)).forEach((x: any) => sortie.push(chemin.join(' › ') + ' : retrait « ' + x + ' »'))
    return
  }
  if (Array.isArray(avant) || Array.isArray(apres)) {
    const a: any[] = avant || [], b: any[] = apres || []
    const noms = (l: any[]) => l.map((e, i) => nomElement(e, i))
    const na = noms(a), nb = noms(b)
    b.forEach((e, i) => {
      const j = na.indexOf(nb[i])
      if (j < 0) sortie.push(chemin.concat(nb[i]).join(' › ') + ' : ajout')
      else comparer(a[j], e, chemin.concat(nb[i]), sortie)
    })
    a.forEach((e, i) => { if (!nb.includes(na[i])) sortie.push(chemin.concat(na[i]).join(' › ') + ' : suppression') })
    return
  }
  if (avant && apres && typeof avant === 'object' && typeof apres === 'object') {
    const cles = Array.from(new Set(Object.keys(avant).concat(Object.keys(apres)))).filter(k => !IGNORES.includes(k))
    cles.forEach(k => comparer(avant[k], apres[k], chemin.concat(libelle(k)), sortie))
    return
  }
  if (JSON.stringify(avant) !== JSON.stringify(apres)) {
    const ou = chemin.slice(0, -1).join(' › ')
    sortie.push((ou ? ou + ' : ' : '') + chemin[chemin.length - 1] + ' ' + texte(avant) + ' → ' + texte(apres))
  }
}

/** Changements de {@code avant} à {@code apres}, une ligne par valeur modifiée, article ajouté ou supprimé. */
export function changementsCatalogue(avant: any, apres: any): string[] {
  const sortie: string[] = []
  comparer(avant || {}, apres || {}, [], sortie)
  return sortie
}

const MARGES = ['pv', 'batterie', 'presta', 'bornes']

/**
 * Saisies invalides du catalogue (03/11/2026), signalées en rouge dans la page et bloquant l'enregistrement : valeur
 * négative, marge de 100 % ou plus, panneau sans puissance, onduleur sans puissance AC max.
 */
export function erreursCatalogue(c: any): string[] {
  const erreurs: string[] = []
  const parcourir = (x: any, chemin: string[]) => {
    if (Array.isArray(x)) { x.forEach((y, i) => parcourir(y, chemin.concat([nomElement(y, i)]))); return }
    if (!x || typeof x !== 'object') return
    Object.keys(x).forEach(k => {
      const v = x[k]
      if (typeof v === 'number') {
        const ou = chemin.concat([libelle(k)]).join(' › ')
        if (v < 0) erreurs.push(ou + ' : valeur négative')
        else if (chemin[0] === libelle('marges') && MARGES.includes(k) && v >= 100) erreurs.push(ou + ' : marge de 0 à moins de 100 %')
      } else if (v && typeof v === 'object' && k !== 'aVerifier') parcourir(v, chemin.concat([libelle(k)]))
    })
  }
  parcourir(c, [])
  ;['particulier', 'pro'].forEach(p => {
    const partie = c[p] || {}
    ;(partie.panneaux || []).forEach((x: any, i: number) => { if (!(x.wc > 0)) erreurs.push(libelle(p) + ' › Panneaux › ' + nomElement(x, i) + ' : puissance manquante') })
    ;(partie.onduleurs || []).forEach((x: any, i: number) => { if (!(x.kva > 0)) erreurs.push(libelle(p) + ' › Onduleurs › ' + nomElement(x, i) + ' : puissance AC max manquante') })
  })
  return erreurs
}
